import { Mapper } from "@shared/interfaces";

export interface ICardDTO {
    title: string;
    data: string;
    description: string;
    descriptionItems: string[];
    backgroundColor: string,
}

export class CardDTO implements Mapper<ICardDTO> {
    constructor(
        public title: string,
        public data: string,
        public description: string,
        public descriptionItems: string[] = [],
        public backgroundColor: string,
        public textColor: string = "white"
    ) { }

    public getJSON(): ICardDTO {
        return {
            title: this.title,
            data: this.data,
            description: this.description,
            descriptionItems: this.descriptionItems,
            backgroundColor: this.backgroundColor,
        }
    }
}
